module.exports = __webpack_public_path__ + "img/erweima.5287a571.png";